import {
  ColorIcon,
  colors,
  useResponsive,
  Button,
  customEvent,
  DirectEventPathType,
  Spacing,
  call,
} from "goi_common";
import { Box, HStack } from "@chakra-ui/react";
import { useCallback, useState } from "react";
import ConsultBottomSheet from "@/components/consult/ConsultBottomSheet";

const ConsultFAB = ({
  path = "call_lead",
  mainColor = colors.orange650,
  showVerificationVariant = false,
  bottomOffset = 0,
  isDirectCall = false,
}: {
  path?: keyof typeof DirectEventPathType;
  mainColor?: string;
  showVerificationVariant?: boolean;
  bottomOffset?: number;
  isDirectCall?: boolean;
}) => {
  const { isBiggerThanMd, isBiggerThanLg } = useResponsive();
  const [isModalVisible, setModalVisible] = useState(false);

  const handleClick = useCallback(() => {
    customEvent({
      newGtm: {
        path,
        trigger_and_target: isDirectCall
          ? "direct_call_click"
          : showVerificationVariant
          ? "open_consult_btm_verification"
          : "consult_mdl_open",
      },
    });

    if (isDirectCall) {
      call("1666-9784");
      return;
    }

    setModalVisible(true);
  }, [path, showVerificationVariant, isDirectCall]);

  return (
    <>
      <Box
        position="fixed"
        bottom={
          isBiggerThanLg
            ? `${120 + bottomOffset}px`
            : isBiggerThanMd
            ? `${104 + bottomOffset}px`
            : `${96 + bottomOffset}px`
        }
        right="16px"
        zIndex={11}
      >
        {isBiggerThanMd ? (
          <Box
            width={220}
            backgroundColor={colors.white}
            padding="24px 16px"
            borderRadius="16px"
            cursor="pointer"
            onClick={handleClick}
            boxShadow="0 4px 16px rgba(0, 0, 0, 0.12)"
            display="flex"
            flexDirection="column"
            gap="16px"
            maxWidth="280px"
          >
            <Box color={colors.black} textAlign="center">
              {showVerificationVariant ? (
                <>
                  <Box className="subtitle_18_b">
                    어려운{" "}
                    <span style={{ color: mainColor }}>휴대폰 본인인증</span>
                  </Box>
                  <Box className="subtitle_18_b">상담원이 도와드릴게요.</Box>
                </>
              ) : (
                <>
                  <Box className="subtitle_18_b">상조 서비스</Box>
                  <Box className="subtitle_18_b">아직 궁금한 게 있다면?</Box>
                </>
              )}
            </Box>
            <Button
              className="button_16_sb"
              css={{
                width: "100%",
                borderRadius: "6px",
                background: mainColor,
                color: colors.white,
                padding: "12px 24px",
              }}
              onClick={handleClick}
            >
              {showVerificationVariant ? "상담원 도움받기" : "상담 신청하기"}
            </Button>
          </Box>
        ) : (
          <HStack
            backgroundColor={colors.white}
            padding="16px"
            borderRadius="24px"
            cursor="pointer"
            onClick={handleClick}
            boxShadow="0 4px 16px rgba(0, 0, 0, 0.12)"
            gap="4px"
          >
            <Box className="button_14_sb" color={colors.black}>
              {showVerificationVariant ? (
                <>
                  <span style={{ color: mainColor }}>휴대폰 본인인증</span>이
                  어렵다면?
                  <Spacing gap={6} />
                  상담원이 친절히 도와드릴게요.
                </>
              ) : (
                "상조 서비스 아직 궁금한 게 있다면?"
              )}
            </Box>
            <Box
              width="28px"
              height="28px"
              borderRadius="50%"
              backgroundColor={mainColor}
              display="flex"
              alignItems="center"
              justifyContent="center"
              flexShrink={0}
            >
              <ColorIcon
                name="arrow_right_small"
                size={20}
                color={colors.white}
              />
            </Box>
          </HStack>
        )}
      </Box>
      <ConsultBottomSheet
        isOpen={isModalVisible}
        onClose={() => setModalVisible(false)}
        path={path}
        hasReasonStep={!showVerificationVariant}
        showCostSavingVariant={false}
        showVerificationVariant={showVerificationVariant}
        trigger={
          showVerificationVariant ? "본인인증 도움 요청" : "랜딩페이지 상담요청"
        }
        defaultReason={
          showVerificationVariant ? "휴대폰 본인인증이 어려워요" : undefined
        }
      />
    </>
  );
};

export default ConsultFAB;
